import React, { useEffect } from 'react';

const Loader = ({ show = false }) => {
  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [show]);

  if (!show) return null;

  return (
    <div className="loader-wrapper">
      <span className="loader">Loading</span>
    </div>
  );
};

export default Loader;
